export default __webpack_public_path__ + "media/components/Courses/Show/Images/check-97615d7541782606c2dbd1cde7b7658d.svg";